// source/Header/index.tsx
import React from "react";
import "./styles.css";

interface NavigationItem {
  key: string;
  navTitle: string;
}

interface HeaderProps {
  navigation: NavigationItem[];
  selected: string;
  onSelect: (key: string) => void;
}

const Header: React.FC<HeaderProps> = ({ navigation, selected, onSelect }) => {
  const activeRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    activeRef.current?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [selected]);

  return (
    <header className="header">
      <div className="nav-scroll">
        <nav>
          <ul className="nav">
            {navigation.map((item) => (
              <li key={item.key}>
                <button
                  ref={selected === item.key ? activeRef : null}
                  type="button"
                  className={`nav-link ${selected === item.key ? "active" : ""}`}
                  onClick={() => onSelect(item.key)}
                >
                  {item.navTitle}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
